<template>
    <div class="Alert">
        <slot />
    </div>
</template>

<style lang="scss" scoped src="./index.scss" />
